import { KButton, KDropdown, KLogo, KSpan, KTitleSpan, KTooltip } from "kahuna-base-react-components"
import { useState } from "react"
import { lang } from "../../../constants/languages"
import { connect } from "react-redux"
import { RootState } from "../../../store"
import { User } from "../../../types"
import { KSelectOption } from "kahuna-base-react-components/dist/components/KDropdown/KDropdown"
import { handleAuthorizedRequest, users } from "../../../apis"
import { useNavigate } from "react-router-dom"
import Analysis from "./Analysis"
//@ts-ignore
import BarChartIcon from "../../../assets/start_your_journey_icons/bar-chart-square.svg"
//@ts-ignore
import SparkleIcon from "../../../assets/admin_icons/music-note-sparkle.svg"
import AdminTrends from "../trends/AdminTrends"

export enum TAB_OPTIONS {
  INSIGHTS = "insights",
  ADMIN_INSIGHTS = "admin_insights"
}

export type AnalysisProps = {
  isAdmin: boolean
  user?: User
}

const AdminAnalysis = ({ user, isAdmin }: AnalysisProps) => {
  const [selectedTab, setSelectedTab] = useState<string | undefined>(undefined)
  const [selectedUsers, setSelectedUsers] = useState<KSelectOption[]>([])
  const [userOptions, setUserOptions] = useState<KSelectOption[]>([])
  const [userTimeoutId, setUserTimeoutId] = useState<ReturnType<typeof setTimeout>>()
  const [openSidebar, setOpenSidebar] = useState<boolean>(true)
  const navigate = useNavigate()

  const onSearchTextChanged = async (text: string) => {
    if (!text) return
    setUserOptions([])
    clearTimeout(userTimeoutId)
    setUserTimeoutId(
      setTimeout(async () => {
        await handleAuthorizedRequest(async () => {
          const response = await users(`/?limit=10&offset=0&username=${text}`, "get")
          setUserOptions(
            response.data.results.map((optionUser: User) => ({
              value: optionUser.id,
              label: optionUser.username
            }))
          )
        }, "")
      }, 500)
    )
  }

  const renderTableTitle = () => {
    const title = selectedTab === TAB_OPTIONS.INSIGHTS ? "Insights" : "Admin Insights"
    return (
      <div className="flex flex-row gap-2 !cursor-default items-center self-start">
        <KTooltip
          backgroundColor="#000"
          padding="0px 4px"
          height="20px"
          arrowColor="#000"
          position="bottom"
          marginLeft="45px"
          content={
            <div className="h-5 w-max flex items-center">
              <KSpan
                text={openSidebar ? lang.trends.hide_sidebar_and_filters : lang.trends.open_sidebar_and_filters}
                fontSize={12}
                lineHeight="16px"
                color="#FFF"
              />
            </div>
          }
        >
          <div className="flex items-center mt-1">
            <KButton
              dataTestId="daily-trends-side-bar"
              icon="/left-sidebar.svg"
              width="32px"
              height="32px"
              background="transparent"
              shadowDisabled={true}
              padding="4px"
              onClick={() => {
                setOpenSidebar(!openSidebar)
              }}
            />
          </div>
        </KTooltip>
        <div className="pt-2 items-center">
          <KTitleSpan text={title} color="#111" fontSize={20} lineHeight="24px" />
        </div>
      </div>
    )
  }

  return (
    <div className="flex flex-row w-full h-screen">
      {
        <div
          className={`${
            openSidebar ? "min-w-[230px]" : "min-w-0 !w-[0px]"
          } max-w-[320px] w-[20%] bg-[#F7F7F7] min-h-[100vh] flex flex-col overflow-hidden shrink-0 h-screen`}
          style={{
            transitionDuration: "0.5s"
          }}
        >
          <div className="pl-4 pr-3 py-4 whitespace-nowrap flex gap-2">
            <div style={{ textAlign: "left", display: "inline-block", cursor: "pointer" }} onClick={() => navigate(-1)}>
              <KLogo hoverEnabled={true} width={36} height={36} logoColor={"white"} borderRadius={1} />
            </div>
            <KTitleSpan text={"Insights"} lineHeight="28px" fontSize={20} color="#111" />
          </div>

          <div>
            <div className="py-1.5 px-4">
              <div
                className={`rounded-[10px] p-2 flex flex-row gap-2 mt-5 ${
                  selectedTab === TAB_OPTIONS.INSIGHTS ? "bg-[#FFF]" : "transparent"
                } cursor-pointer whitespace-nowrap items-center`}
                onClick={() => {
                  setSelectedTab(TAB_OPTIONS.INSIGHTS)
                }}
              >
                <img src={BarChartIcon} width={20} height={20} className="shrink-0" />
                <KSpan text={"Insights"} fontSize={14} lineHeight="16px" fontWeight={500} color="#111" />
              </div>
              {isAdmin && <div
                className={`rounded-[10px] p-2 flex flex-row gap-2 mt-1 ${
                  selectedTab === TAB_OPTIONS.ADMIN_INSIGHTS ? "bg-[#FFF]" : "transparent"
                } cursor-pointer whitespace-nowrap items-center`}
                onClick={() => {
                  setSelectedTab(TAB_OPTIONS.ADMIN_INSIGHTS)
                }}
              >
                <img src={BarChartIcon} width={20} height={20} className="shrink-0" />
                <KSpan text={"Admin Insights"} fontSize={14} lineHeight="16px" fontWeight={500} color="#111" />
              </div>}
            </div>
            <div className="py-1.5 px-4 mt-6">
              <KDropdown
                isMulti={true}
                placeholder={"Search user to filter"}
                closeMenuOnSelect={false}
                selected={selectedUsers}
                disableFilterOption={true}
                onInputChange={onSearchTextChanged}
                options={userOptions}
                isClearable={true}
                onBlur={(selectedOption) => {
                  if (!selectedOption) {
                    setSelectedUsers([])
                    return
                  }
                  setSelectedUsers(selectedOption as KSelectOption[])
                }}
                onSelect={() => {
                  // do nothing
                }}
              />
            </div>
          </div>
        </div>
      }
      <div className="flex flex-col grow gap-2 py-3 pl-8 pr-[52px] overflow-x-auto overflow-y-scroll">
        {selectedTab && <div className="w-full flex items-center">{renderTableTitle()}</div>}
        {selectedTab === TAB_OPTIONS.INSIGHTS && <Analysis isAdmin={isAdmin} selectedUsers={selectedUsers}/>}
        {selectedTab === TAB_OPTIONS.ADMIN_INSIGHTS && isAdmin && <AdminTrends selectedUsers={selectedUsers} />}
      </div>
    </div>
  )
}

const mapStateToProps = (state: RootState) => {
  return {
    user: state.auth.user
  }
}

export default connect(mapStateToProps, {})(AdminAnalysis)
